<div class="main-section">
  <div class="feature-content">
    <div class="v2">
      <div class="top">
        <div class="title-area">
          <div class="text">
            <img alt="Logo" class="logo" src="../../../assets/images/MediaLab_Logo.png" />
            <div class="title">Product Health Check</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <table class="standard">
          <thead>
            <tr>
              <th>Product</th>
              <th>Link</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (check of productHealthChecks; track check.Name) {
              <tr>
                <td class="nowrap">
                  {{ check.Name }}
                </td>
                <td>
                  <a href="{{ check.Link }}" target="_blank">{{ check.Link }}</a>
                </td>
                <td class="center-align">
                  @if (check.HasChecked) {
                    @if (check.IsHealthy) {
                      <ml-icon class="success" name="check"></ml-icon>
                    } @else {
                      <ml-icon class="error" name="alert"></ml-icon>
                    }
                  } @else {
                    <loading-indicator></loading-indicator>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <toast></toast>
</div>